/**
 * BSF Cart Toast - Lightweight toast notifications inside cart drawer
 * ~800 bytes minified | No dependencies | 60fps animations
 */
class BsfCartToast {
  constructor() {
    this.toast = null;
    this.hideTimer = null;
    this.drawer = null;
  }

  init(container) {
    if (this.toast) return;
    this.drawer = container;

    // Create toast element inside cart container (fixed at bottom)
    this.toast = document.createElement('div');
    this.toast.className = 'bsf-cart-toast';
    this.toast.setAttribute('role', 'status');
    this.toast.setAttribute('aria-live', 'polite');

    // BSF: Place toast INSIDE footer (absolute positioned, floats above)
    // Supports both cart drawer and /cart page
    const footer = container.querySelector('.m-cart-drawer__footer')
                || container.querySelector('.m-cart__footer--wrapper');
    if (footer) {
      footer.appendChild(this.toast);
    }
  }

  show(message, type = 'info', duration = 2500) {
    if (!this.toast) {
      const container = document.querySelector('m-cart-drawer') || document.querySelector('m-cart');
      if (container) this.init(container);
      else return;
    }

    clearTimeout(this.hideTimer);

    // Icons: checkmark (success/info/removed), spinner (loading/removing), X (error)
    const checkmark = '<svg class="bsf-toast-icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>';
    const spinner = '<span class="bsf-toast-spinner"></span>';
    const icons = {
      success: checkmark,
      error: '<svg class="bsf-toast-icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>',
      loading: spinner,
      removing: spinner,
      removed: checkmark,
      info: checkmark
    };

    this.toast.innerHTML = icons[type] || icons.info;
    const span = document.createElement('span');
    span.textContent = message;
    this.toast.appendChild(span);
    this.toast.className = 'bsf-cart-toast bsf-cart-toast--' + type;

    // Force reflow for animation restart
    void this.toast.offsetWidth;
    this.toast.classList.add('bsf-cart-toast--visible');

    this.hideTimer = setTimeout(() => this.hide(), duration);
  }

  hide() {
    if (this.toast) {
      this.toast.classList.remove('bsf-cart-toast--visible');
    }
  }

  // Convenience methods using BsfCartStrings
  adding() {
    const s = window.BsfCartStrings || {};
    this.show(s.adding || 'Adding to cart...', 'loading', 10000);
  }

  added(name) {
    const s = window.BsfCartStrings || {};
    this.show(s.added || 'Added to cart', 'success');
  }

  updated() {
    const s = window.BsfCartStrings || {};
    this.show(s.updated || 'Cart updated', 'success');
  }

  removing() {
    const s = window.BsfCartStrings || {};
    this.show(s.removing || 'Removing product...', 'removing', 10000);
  }

  removed() {
    const s = window.BsfCartStrings || {};
    this.show(s.removed || 'Product removed', 'removed');
  }

  error(msg) {
    const s = window.BsfCartStrings || {};
    this.show(msg || s.error || 'An error occurred', 'error', 4000);
  }
}

window.BsfCartToast = new BsfCartToast();
